import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatFromChannel, maskEmailAddress } from '../../../util/formatUtil';
import { SMS, EMAIL } from '../../../constants/conversationTypes';

import { SearchAsk, SearchInputText, SearchImageLeft, SearchImageRight } from '../common/PageLayout.styles';

class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      isInputFocused: false,
    };
  }

  componentDidMount() {
    if (!this.state.searchValue.length) {
      this.setState({ searchValue: this.props.defaultValue });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultValue !== nextProps.defaultValue) {
      this.setState({
        searchValue: nextProps.defaultValue || '',
      });
    }
  }

  setSearchValue(value, defaultValue) {
    const maskedEmail = maskEmailAddress(defaultValue);

    if (value === maskedEmail) {
      return this.setState({ ...this.state, searchValue: defaultValue });
    }

    this.setState({ ...this.state, searchValue: value });
  }

  runSearchOnEnter(event) {
    if (event.key === 'Enter') {
      const { onClickFunction } = this.props;

      onClickFunction(this.state.searchValue);
    }
  }

  render() {
    const {
      onClickFunction,
      defaultValue = null,
      placeholder = null,
      messageImg = true,
      defaultValueType,
    } = this.props;

    const shouldMaskValue =
      [SMS, EMAIL].includes(defaultValueType) && defaultValue && this.state.searchValue === defaultValue;

    return (
      <SearchAsk focused={this.state.isInputFocused}>
        <SearchImageLeft hide={!messageImg}>
          {messageImg ? <img src="/images/message-box.svg" alt="" /> : null}{' '}
        </SearchImageLeft>
        <SearchInputText
          value={shouldMaskValue ? formatFromChannel(defaultValueType, this.state.searchValue) : this.state.searchValue}
          key={defaultValue}
          onFocus={() => this.setState({ isInputFocused: true })}
          onBlur={() => this.setState({ isInputFocused: false })}
          onChange={(event) => this.setSearchValue(event.target.value, defaultValue)}
          placeholder={placeholder || 'Ask a question'}
          onKeyUp={(event) => this.runSearchOnEnter(event)}
        />
        <SearchImageRight onClick={() => onClickFunction(this.state.searchValue)}>
          <img style={{ width: '15px' }} src="/images/magnifying-glass.svg" alt="" />
        </SearchImageRight>
      </SearchAsk>
    );
  }
}

SearchInput.propTypes = {
  onClickFunction: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  defaultValueType: PropTypes.string,
  placeholder: PropTypes.string,
};

export default SearchInput;
